import { Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { DevIdentitySwitcher } from '@cusp/api-client/dev';
import { ThemeToggle } from '@cusp/theme';
import { AccountMenu } from './components/AccountMenu.js';

export function AppShell() {
  return (
    <div className="shell">
      <header>
        <span className="brand">
          CUSP<small>Learner</small>
        </span>
        <div className="header-controls">
          <ThemeToggle />
          {/* The same account card the landing page and the learner masthead
              draw: a live session (or a dev identity) shows the card and its
              menu; with neither, the dev switcher still drives header auth
              outside production. */}
          <AccountMenu devFallback={<DevIdentitySwitcher preferRole="learner" />} />
        </div>
      </header>
      <main>
        {/* React.lazy screens need a boundary — the router's own pending
            component only covers loader work, not module fetches. */}
        <Suspense fallback={<p>Loading…</p>}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
